import React from 'react';

const navComponent = props => {
  return (
      <div className="heading">
        <div className="feature-img">
          <a href="index.html">
            <img src="assets/images/nick2.jpg"
                 className="responsive-img"
                 alt="Nick Chiafullo - Software Engineer"
            />
          </a>
        </div>
        {/*<div className="nav-icon">*/}
          {/*<nav>*/}
            {/*<div className="nav-wrapper">*/}
              {/*<ul id="nav-mobile" className="side-nav">*/}
                {/*<li><a href="index.html">Resume</a></li>*/}
                {/*<li><a href="project.html">Projects</a></li>*/}
                {/*<li><a href="cover-latter.html">Cover Latter</a></li>*/}
                {/*<li><a href="blog.html">Blog</a></li>*/}
                {/*<li><a href="contact.html">Contact</a></li>*/}
              {/*</ul>*/}
              {/*<a href="#" data-activates="nav-mobile" className="button-collapse ">*/}
                {/*<i className="mdi-navigation-menu"/>*/}
              {/*</a>*/}
            {/*</div>*/}
          {/*</nav>*/}
        {/*</div>*/}
        <div className="title col s12 m12 l9 right  wow fadeIn" data-wow-delay="0.1s">
          <h2>Nick Chiafullo</h2>
        </div>
      </div>
  )
};

export default navComponent;